module.exports = __webpack_public_path__ + "img/caseImg.0a4c4f0a.png";